import React from 'react';
import TopStepAccountPage from './TopStepAccountPage';

const TopStepJoshChallengePage: React.FC = () => (
  <TopStepAccountPage
    accountLabel="TopStep - Josh's Challenge"
    accountMatcher={(accts) => {
      const JOSH_ACCOUNT_ID = 21860708;
      const JOSH_ACCOUNT_MARKER = '573439-66396710';
      const KNOWN_ACCOUNT_MARKERS = ['572700-94071834', '572700-47336468', '100K', '150K'];
      const isKnown = (name: string) => KNOWN_ACCOUNT_MARKERS.some((m) => name.toUpperCase().includes(m.toUpperCase()));

      // Hard lock to the newly provisioned 50K combine account when present.
      const exact = accts.find((a) => a.accountId === JOSH_ACCOUNT_ID || a.accountName.includes(JOSH_ACCOUNT_MARKER));
      if (exact) return exact;

      // Prefer explicit Josh/cottoisaiah identifiers if present in TopStep account naming.
      const explicit = accts.find((a) => {
        const name = a.accountName.toUpperCase();
        return name.includes('JOSH') || name.includes('COTTOISAIAH');
      });
      if (explicit) return explicit;

      // Then prefer an unclaimed 50K challenge account.
      const fiftyK = accts.find((a) => {
        const name = a.accountName.toUpperCase();
        return !isKnown(a.accountName) && name.includes('50K');
      });
      if (fiftyK) return fiftyK;

      // Final fallback: first unclaimed account if naming differs from standard patterns.
      return accts.find((a) => !isKnown(a.accountName));
    }}
    challengeParams={{ target: 4500, hardMax: 2000, internalStop: 1700, dailyCap: 600, accountSize: 50000 }}
    chipLabel="JOSH 50K"
    chipColor="#FFB74D"
  />
);

export default TopStepJoshChallengePage;
